var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _g3, _path39, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackerNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1506_13613)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.361 148.86H96.8008C104.921 136.2 118.921 119.98 135.561 125.78C146.101 83.5398 207.081 86.6998 213.201 129.78C226.021 122.06 242.561 134.98 241.361 148.86Z",
    fill: "#CEDEF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.961 92.1798H330.881C337.221 86.4998 345.921 84.5798 354.281 86.1798C361.341 69.2798 386.801 68.1198 395.381 84.2998C400.581 79.9198 407.501 84.1998 411.721 88.0598C416.741 78.2398 430.621 83.0598 432.961 92.1798Z",
    fill: "#CEDEF2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1506_13613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 95,
    width: 500,
    height: 403
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 95H0V498H500V95Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1506_13613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.12 557.1C178.642 557.1 221.22 514.523 221.22 462C221.22 409.478 178.642 366.9 126.12 366.9C73.5973 366.9 31.0195 409.478 31.0195 462C31.0195 514.523 73.5973 557.1 126.12 557.1Z",
    fill: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.719 479.24C471.928 479.24 487.499 463.669 487.499 444.46C487.499 425.252 471.928 409.68 452.719 409.68C433.511 409.68 417.939 425.252 417.939 444.46C417.939 463.669 433.511 479.24 452.719 479.24Z",
    fill: "#F0EFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.259 475.46C380.516 475.46 436.659 419.317 436.659 350.06C436.659 280.804 380.516 224.66 311.259 224.66C242.003 224.66 185.859 280.804 185.859 350.06C185.859 419.317 242.003 475.46 311.259 475.46Z",
    fill: "#F0EFEF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 498H72.84",
    stroke: "#BCBEC0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0391 498H499.999",
    stroke: "#BCBEC0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M134.56 327.68L112.58 309.2",
    stroke: "#D1D3D4",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.962 337.24L139.262 331.6",
    stroke: "#D1D3D4",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.86 375.9L284.42 285.22L187.82 204.12L123.76 277.56L114.28 295.94C112.28 298.22 112.56 301.42 114.92 303.42L202.1 376.6C204.9 378.94 209.48 378.62 211.86 375.9Z",
    fill: "#F0CD76"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M162.081 309.02L151.641 325.84L155.841 326.74L157.281 330.64L160.061 330.82L161.361 334.14L164.781 335.14L167.421 339.32L177.861 322.5L162.081 309.02Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M281.24 282.56L216.18 355.14L123.74 277.54L187.8 204.1L281.24 282.56Z",
    fill: "#EDA26B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M281.242 282.56L216.182 355.14L243.122 357.14L307.182 283.7L281.242 282.56Z",
    fill: "#F0CD76"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M161.881 202.96L96.8008 275.54L123.741 277.54L187.801 204.1L161.881 202.96Z",
    fill: "#F0CD76"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M261.2 304.9L281.24 282.56L187.8 204.1L175.84 232.92L261.2 304.9Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M123.74 277.54L187.8 204.1L175.84 232.92L130.74 283.4L123.74 277.54Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M303.822 145.9C304.082 146.78 303.821 147.62 303.241 147.8C302.661 147.96 302.001 147.4 301.741 146.52C301.481 145.64 301.742 144.8 302.322 144.62C302.902 144.44 303.582 145.02 303.822 145.9Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M303.922 147.62C303.922 147.62 303.402 153.28 301.922 156.38C303.902 157.38 306.362 155.94 306.362 155.94L303.922 147.62Z",
    fill: "#F48380"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M305.621 140.08C305.741 140.02 305.821 139.92 305.881 139.78C305.981 139.5 305.841 139.2 305.561 139.1C302.761 138.12 300.761 139.6 300.681 139.66C300.441 139.84 300.401 140.18 300.581 140.42C300.761 140.66 301.101 140.7 301.341 140.52C301.401 140.48 302.961 139.32 305.201 140.12C305.341 140.16 305.481 140.14 305.621 140.08Z",
    fill: "#263238"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M334.101 151.72C334.701 158.94 336.481 172.18 340.741 175.2C340.741 175.2 339.721 183.88 324.441 186.12C307.641 188.6 315.181 178.96 315.181 178.96C324.021 175.42 322.781 168.64 320.241 162.5L326.741 155.06C329.181 152.28 333.801 148.04 334.101 151.72Z",
    fill: "#F9B4A6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M346.242 178.72C347.602 177.48 344.842 172.52 343.202 171.84C338.822 170 320.882 171.82 314.122 177.62C312.202 180.7 313.602 184 313.602 184L346.242 178.72Z",
    fill: "#154B84"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M339.461 486.72H328.101L326.961 460.42H338.321L339.461 486.72Z",
    fill: "#FABFBF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M398.942 476.08L388.002 477.68L381.922 451.3L392.882 449.7L398.942 476.08Z",
    fill: "#FABFBF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M386.021 474.66L398.701 473.24C399.161 473.18 399.601 473.46 399.741 473.9L403.081 483.68C403.421 484.7 402.721 485.78 401.661 485.88C397.221 486.3 395.041 486.28 389.461 486.9C386.021 487.28 377.261 488.84 372.481 488.9C367.821 488.96 367.041 484.24 368.981 483.8C377.721 481.78 381.741 478.38 384.241 475.56C384.721 475.06 385.361 474.74 386.021 474.66Z",
    fill: "#263238"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M328.182 485.4H340.582C341.042 485.4 341.442 485.72 341.542 486.18L343.782 496.28C344.022 497.32 343.222 498.32 342.142 498.3C337.662 498.22 331.202 497.96 325.582 497.96C319.002 497.96 316.222 498.32 308.522 498.32C303.862 498.32 302.562 493.6 304.522 493.18C313.402 491.24 317.762 491.02 325.442 486.3C326.262 485.78 327.202 485.4 328.182 485.4Z",
    fill: "#263238"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M343.122 246.78L332.342 250.02L339.242 261.36C339.242 261.36 345.582 258.74 346.982 253.36L343.122 246.78Z",
    fill: "#FABFBF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M328.082 254.02L332.302 263.36L339.222 261.34L332.342 250.02L328.082 254.02Z",
    fill: "#FABFBF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M336.083 185.52C334.203 191.98 361.483 208.9 371.123 220.4L365.083 235.12L368.123 252.12C368.123 252.12 377.883 245.68 388.783 218.58C390.843 213.44 383.263 201.1 365.603 184C354.743 173.52 340.743 169.54 336.083 185.52Z",
    fill: "#D84154"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M298.36 184.66C298.36 184.66 288.4 199.94 312.04 281.9L372.16 273.02C371.32 264.7 361.26 228.48 360.92 188.86C360.86 180.82 354.1 174.42 346.06 174.82C344.3 174.9 342.5 175.04 340.74 175.22C333 175.98 321.84 177.38 315.18 179C306.42 181.1 298.36 184.66 298.36 184.66Z",
    fill: "#5274B8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M298.36 184.66C298.36 184.66 288.4 199.94 312.04 281.9L372.16 273.02C371.32 264.7 361.26 228.48 360.92 188.86C360.86 180.82 354.1 174.42 346.06 174.82C344.3 174.9 342.5 175.04 340.74 175.22C333 175.98 321.84 177.38 315.18 179C306.42 181.1 298.36 184.66 298.36 184.66Z",
    fill: "#D84154"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M296.881 210.98L297.081 210.74L311.221 212C313.361 221.12 305.501 233.58 301.341 239.34C298.941 227.66 297.581 218.36 296.881 210.98Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M332.602 135.44C335.102 146.44 337.142 152.74 333.302 159.88C327.542 170.62 312.762 169.6 307.022 159.56C301.862 150.54 298.622 134.08 307.942 126.68C317.122 119.4 330.102 124.44 332.602 135.44Z",
    fill: "#F9B4A6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M310.541 146.22L306.361 148.78L306.761 134.48C306.761 134.48 302.381 134.78 299.201 132.28C300.721 130.84 324.241 122.6 331.581 124.04C332.341 123.72 333.281 122.3 333.281 122.3C333.281 122.3 333.561 124.08 332.321 124.76C333.221 124.58 335.461 125.02 336.101 126.34C334.121 125.92 332.981 126.52 332.981 126.52C332.981 126.52 341.221 127.76 338.261 139.08C335.001 151.56 336.081 158.76 336.081 158.76C336.081 158.76 330.001 163.46 324.721 162.58C319.041 156.38 310.921 148.9 310.541 146.22Z",
    fill: "#263238"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M302.54 131.14C295.9 131.2 293.52 127.9 291.82 125.18C296.58 124.66 306.52 121.6 313.9 121.1C321.28 120.58 329.34 121.96 326.9 125.12C324.44 128.3 302.54 131.14 302.54 131.14Z",
    fill: "#263238"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M304.001 128.18C298.581 127.42 293.241 122.28 297.321 117.36C298.841 120.98 309.041 120.56 316.281 119.04C325.781 117.06 332.421 120.26 329.041 126.76C327.181 130.32 304.001 128.18 304.001 128.18Z",
    fill: "#263238"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M316.42 142.96C317.28 145.78 316.96 148.86 316.06 151.14C314.7 154.56 311.68 153.86 310.1 150.9C308.68 148.24 307.7 143.24 310 140.78C312.3 138.34 315.44 139.72 316.42 142.96Z",
    fill: "#F9B4A6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M333.381 278.74C333.381 278.74 343.141 326.72 350.221 359.24C357.981 394.86 379.861 466.1 379.861 466.1L397.801 462.44C397.801 462.44 388.441 413.1 381.941 363.3C376.941 325.06 385.621 307.98 372.181 273L333.381 278.74Z",
    fill: "#154B84"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M340.74 302.26C340.74 302.26 345.7 336.62 349.14 354.12C354.12 327.34 357.38 309.6 340.74 302.26Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M312.042 281.88C312.042 281.88 303.962 324.82 305.182 359.46C306.462 395.5 325.042 477.68 325.042 477.68L341.822 474.68C341.822 474.68 339.002 397.6 339.842 362.2C340.782 323.62 355.242 275.48 355.242 275.48L312.042 281.88Z",
    fill: "#154B84"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M316.222 200.18C284.402 263.36 235.002 246.76 235.002 246.76V234.48C235.002 234.48 272.042 245.68 291.262 189.76C293.342 183.72 306.382 179.58 312.782 182.36C319.182 185.16 318.902 194.86 316.222 200.18Z",
    fill: "#D84154"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M237.041 234.86L223.061 232.3L224.541 244.4C224.541 244.4 231.801 248.46 237.081 242.1L237.041 234.86Z",
    fill: "#F9B4A6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M217.701 235.02L220.721 243.76L224.541 244.4L223.081 232.3L217.701 235.02Z",
    fill: "#F9B4A6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M336.74 147.38C336.74 147.38 325.92 143.86 316.1 128.98L298.86 129.24C294.14 128.06 292.2 123.28 292.62 118.78C292.6 117.82 293.5 117.12 294.42 117.36L311.24 117.14C332.44 108 349.88 128.46 336.74 147.38Z",
    fill: "#E32130"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1506_13613",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 292,
    y: 114,
    width: 50,
    height: 34
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M336.74 147.38C336.74 147.38 325.92 143.86 316.1 128.98L298.86 129.24C294.14 128.06 292.2 123.28 292.62 118.78C292.6 117.82 293.5 117.12 294.42 117.36L311.24 117.14C332.44 108 349.88 128.46 336.74 147.38Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1506_13613)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.261 117.14C311.261 117.14 309.041 124.18 316.101 128.98C316.101 128.98 312.081 117.6 317.281 115.02C317.281 115.04 313.041 115.86 311.261 117.14Z",
    fill: "#1D58A6"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M332.7 120.74C335.76 123.06 337.38 120.86 334.3 118.6C331.24 116.28 329.6 118.48 332.7 120.74Z",
    fill: "#1D58A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1506_13613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackerNotFound);
export default __webpack_public_path__ + "static/media/packer-not-found.96e7608beb3f9ed974e502160f263c89.svg";
export { ForwardRef as ReactComponent };